import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { ApiBaseUrlContext } from '../App';
import { ReactComponent as LinkArrowIcon } from '../assets/svg/icon-small-arrow.svg';
import { useNavigate } from 'react-router-dom';
import { formatDateByLocale } from '../utils/dateUtils';

const Section3 = () => {
  const apiBaseUrl = useContext(ApiBaseUrlContext);
  const [maintenance, setMaintenance] = useState([]);
  const [faults, setFaults] = useState([]);
  const [machines, setMachines] = useState([]);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  
  // Fetch machine data
  useEffect(() => {
    const fetchMachines = async () => {
      try {
        const machineResponse = await axios.get(`${apiBaseUrl}/mnt/api/machines/all`);
        console.log('Machines Data:', machineResponse.data);
        setMachines(machineResponse.data);
      } catch (error) {
        console.error('Error fetching machines:', error);
      }
    };
    fetchMachines();
  }, [apiBaseUrl]);

  // Fetch maintenance and fault data
  useEffect(() => {
    const fetchMaintenanceAndFaults = async () => {
      try {
        // Fetch open maintenance data
        const maintenanceResponse = await axios.get(`${apiBaseUrl}/mnt/api/maintenance`, {
          params: { status: 'Open' }
        });
        console.log('Maintenance Response:', maintenanceResponse.data);
        setMaintenance(Array.isArray(maintenanceResponse.data) ? maintenanceResponse.data : []);

        // Fetch open faults data
        const faultsResponse = await axios.get(`${apiBaseUrl}/mnt/api/fault-errors`, {
          params: { status: 'Open' }
        });
        console.log('Faults Response:', faultsResponse.data);
        setFaults(Array.isArray(faultsResponse.data) ? faultsResponse.data : []);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchMaintenanceAndFaults();
  }, [apiBaseUrl]);

  // Get at most 5 entries for maintenance and faults
  const openMaintenance = Array.isArray(maintenance) ? maintenance.slice(0, 5) : [];
  const repairsInProgress = Array.isArray(faults) ? faults.slice(0, 5) : [];

  // Filter out maintenance tasks that reference an unknown machine
  const filteredOpenMaintenance = openMaintenance.filter(task =>
    machines.some(m => m.machineid === task.machineid)
  );

  // Optionally, filter fault entries if needed
  const filteredRepairsInProgress = repairsInProgress.filter(fault =>
    fault.machine && fault.machine !== t('Section3.UnknownMachine')
  );

  // Helper function to find machine name by ID
  const getMachineName = (machineid) => {
    const machine = machines.find((m) => m.machineid === machineid);
    return machine ? machine.machine : t('Section3.UnknownMachine');
  };

  const handleButtonClick = () => {
    navigate('/maintenance-schedule');
  };

  return (
    <div className="db-box db-box_order-3">
      <div className="db-box__title-row">        
        <button
          type="button"
          className="db-box__title-btn"
          aria-label="{t('Section3.MaintenanceInProcess')}"
          id="errors"
          onClick={handleButtonClick}
        >
          {t('Section3.MaintenanceInProcess')} 
          <LinkArrowIcon />
        </button>

        <div className="db-box__title-stat">
          {maintenance.length} {t('Section3.Open')}
        </div>

        <div className="db-box__title-stat">
          {faults.length} {t('Section3.InProgress')}
        </div>    
      </div>
      
      <div className="db-box__section-header">{t('Section3.OpenMaintenance')}</div>
      {filteredOpenMaintenance.length > 0 ? (
        filteredOpenMaintenance.map((task, index) => (
          <div className="db-box__entry-container db-box__entry-container-blue" key={index}>
            <div className="db-box__entry-row-top">
              <div className="db-box__label db-box__label-blue">{t('Section3.ButtonOpen')}</div>
              <div className="db-box__entry-date">
                {formatDateByLocale(task.open, i18n.language)} ({task.maintenance_type})
              </div>
            </div>
            <div className="db-box__entry-eqipment-name">{getMachineName(task.machineid)}</div>
          </div>
        ))
      ) : (
        <div className="db-box__section-text">{t('Section3.NoOngoingMaintenance')}</div>
      )}

      <div className="db-box__section-header">{t('Section3.RepairsInProgress')}</div>
      {filteredRepairsInProgress.length > 0 ? (
        filteredRepairsInProgress.map((fault, index) => (
          <div className="db-box__entry-container db-box__entry-container-blue" key={index}>
            <div className="db-box__entry-row-top">
              <div className="db-box__label db-box__label-blue">{t('Section3.ButtonInProgress')}</div>
              <div className="db-box__entry-date">
                {formatDateByLocale(Math.floor(fault.created / 1000), i18n.language)} ({fault.technician})
              </div>
            </div>
            <div className="db-box__entry-eqipment-name">{fault.machine}</div>
          </div>
        ))
      ) : (
        <div className="db-box__section-text">{t('Section3.NoRepairsInProgress')}</div>
      )}
    </div>
  );
};

export default Section3;
